import React, { useContext } from 'react'
import { Outlet } from 'react-router-dom';

import { MobileHeader } from '../Header';
import Sidebar from '../Sidebar/Sidebar'
import { NewContext } from '../../Context/NewContext';

import './layout.css';

const Layout = () => {
    const { currentTableData } = useContext(NewContext)

    const tableElem = document.querySelector('.table-responsive')
    if (tableElem) {
        if (currentTableData?.length > 0 && currentTableData?.length < 5) {
            tableElem.classList.add('pb-25');
        } else {
            tableElem.classList.remove('pb-25');
        }
    }
    return (
        <div>
            <Sidebar />
            <main className='main ms-0 ms-xl-auto'>
                {<MobileHeader />}
                <Outlet />
            </main>
        </div>
    )
}

export default Layout